export const BLOG_SEGMENT = 'blog';

export const buildBlogPath = () => `/${BLOG_SEGMENT}`;
export const buildBlogPostPath = (post = {}) => {
  if (typeof post.path === 'string' && post.path.startsWith('/')) return post.path;

  return post.audio ? `/${BLOG_SEGMENT}/podcast/${post.id}` : `/${BLOG_SEGMENT}/${post.id}`;
};

export const isInternalHref = (href = '') => href.startsWith('/') && !href.startsWith('//');

export const buildContentPrerenderPaths = (posts = []) => [buildBlogPath(), ...posts.map(buildBlogPostPath)];
